import { render, staticRenderFns } from "./Step2CustomerDetails.vue?vue&type=template&id=2242515c&scoped=true"
import script from "./Step2CustomerDetails.vue?vue&type=script&lang=js"
export * from "./Step2CustomerDetails.vue?vue&type=script&lang=js"
import style0 from "./Step2CustomerDetails.vue?vue&type=style&index=0&id=2242515c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2242515c",
  null
  
)

export default component.exports